/**
 * First candidate that's non-empty after trimming — '' if none qualify. Use in place of `??`/`||`
 * fallback chains for backend name fields: some rows send an empty string or a whitespace-only
 * value (e.g. " ") rather than null/undefined for "no name yet", which both `??` (only treats
 * null/undefined as absent) and `||` (empty string is falsy, but whitespace is truthy) let through
 * as if it were real, rendering a blank-looking label instead of falling back.
 */
export function firstNonBlank(...candidates: readonly (string | null | undefined)[]): string {
  for (const c of candidates) {
    if (c?.trim()) return c;
  }
  return '';
}
